import React from 'react'

let d = new Date();
let currentYear = d.getFullYear();

const Footer = (props) => (
    <footer id="footer">
        <ul className="icons">
            <li><a href="https://www.facebook.com/imbibeinfo/" className="icon fa-facebook" target="_blank"><span className="label">Facebook</span></a></li>
            <li><a href="https://twitter.com/weimbibe" className="icon fa-twitter" target="_blank"><span className="label">Twitter</span></a></li>
            <li><a href="https://www.instagram.com/weimbibe/" className="icon fa-instagram" target="_blank"><span className="label">Instagram</span></a></li>
            {/*<li><a href="#" className="icon alt fa-behance"><span className="label">Behance</span></a></li>*/}
            {/*<li><a href="#" className="icon alt fa-vimeo"><span className="label">Vimeo</span></a></li>*/}
            {/*<li><a href="#" className="icon alt fa-youtube"><span className="label">YouTube</span></a></li>*/}
            <li><a href="https://www.linkedin.com/company/imbibe-a-brand-design-firm/" className="icon fa-linkedin" target="_blank"><span className="label">LinkedIn</span></a></li>
        </ul>
        <ul className="copyright">
            <li>&copy; {currentYear} IMBIBE. All rights reserved.</li>
        </ul>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js